var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new icon / edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34,3 C9.89228475,3 10.34,3.44771525 10.34,4 C10.34,4.55228475 9.89228475,5 9.34,5 L9.34,5 L4,5 C3.44771525,5 3,5.44771525 3,6 L3,6 L3,20 C3,20.5522847 3.44771525,21 4,21 L4,21 L18,21 C18.5522847,21 19,20.5522847 19,20 L19,20 L19,14.66 C19,14.1077153 19.4477153,13.66 20,13.66 C20.5522847,13.66 21,14.1077153 21,14.66 L21,14.66 L21,20 C21,21.6568542 19.6568542,23 18,23 L18,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,20 L1,6 C1,4.34314575 2.34314575,3 4,3 L4,3 Z M18.7071068,1.29289322 L22.7071068,5.29289322 C23.0976311,5.68341751 23.0976311,6.31658249 22.7071068,6.70710678 L12.7071068,16.7071068 C12.5195704,16.8946432 12.2652165,17 12,17 L8,17 C7.44771525,17 7,16.5522847 7,16 L7,12 C7,11.7347835 7.10535684,11.4804296 7.29289322,11.2928932 L17.2928932,1.29289322 C17.6834175,0.902368927 18.3165825,0.902368927 18.7071068,1.29289322 Z M18,3.41421356 L9,12.4142136 L9,15 L11.5857864,15 L20.5857864,6 L18,3.41421356 Z",
    id: "path-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-icon-/-edit",
    transform: "translate(64.000000, 856.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#304FFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-black"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/edit-new.8eb1a3138309aec9044217873f7b6dd7.svg";
export { ForwardRef as ReactComponent };